import cloneDeep from 'lodash/cloneDeep';
//import {APP_CONFIGS} from "../../config/configs";

const DEFAULT_ORIGIN = null;//APP_CONFIGS.CITY_PAIRS.en.find(cp => cp.code === 'PDL');
const DEFAULT_DESTINATION = null;//APP_CONFIGS.CITY_PAIRS.en.find(cp => cp.code === 'LIS');

export const COURSE = cloneDeep({
    refreshing: false,
    origin: DEFAULT_ORIGIN,
    destination: DEFAULT_DESTINATION,
    dateStart: null,
    dateEnd: null,
    errors: []
});

export const STOPOVER_LEG = {
    selectedAirport: null,
    numberOfNights: null,
    departureDate: null,
    availability: null,
    message: null,
    disabledAirports: [],
    disabledNights: {
        PDL: [],
        TER: []
    },
}

const DEFAULT_STATE = {
    roundTrip: 'RETURN',
    imagineMode: false,
    adultsAmount: 1,
    childrenAmount: 0,
    infantsAmount: 0,
    passengerType: 'ADULT',
    promoCode: typeof window.CODE === 'string' ? window.CODE.substring(0,6) : '',
    passengerTypeWasChanged: false,
    stopover: {
        eligible: false,
        eligibleCityPairs: [],
        availabilityLoaded: false,
        outgoing: {...STOPOVER_LEG},
        incoming: {...STOPOVER_LEG}
    },
    legs: [{...COURSE}, {...COURSE}]
};

export default cloneDeep(DEFAULT_STATE);